<template>
  <b-modal
    v-model="modal"
    class="position-relative"
    lazy
    centered
    body-class="py-5"
    content-class="new-section-modal overflow-visible"
    size="xl"
    hide-footer
    hide-header
  >
    <i
      class="fa fa-close z-[50] absolute top-[15px] right-[17px] text-[16px] text-[#6E747A] transition cursor-pinter hover:opacity-60"
      @click="modal = false"
    />
    
    <h3 class="text-center text-2xl font-semibold font-[ProximaNova] mb-0 p-0">
      {{ project.name }}
    </h3>

    <div class="w-[435px] mx-auto mt-12">
      <b-form-group class="relative w-full">
        <b-form-input
          v-model="searchQuery"
          placeholder="Search pages…"
          class="h-[40px]"
          @input="onSearch"
        />

        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="absolute top-1/2 -translate-y-1/2 right-3"
        >
          <mask
            id="mask0_15295_11309"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="27"
            height="27"
          >
            <rect
              width="27"
              height="27"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_15295_11309)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.1743 14.0365C18.053 11.4004 17.8098 7.71703 15.4448 5.35203C12.8088 2.71599 8.53494 2.71599 5.8989 5.35203C3.26287 7.98807 3.26287 12.2619 5.8989 14.898C8.26391 17.263 11.9473 17.5061 14.5834 15.6275L21.0133 22.0574L22.6043 20.4664L16.1743 14.0365C18.053 11.4004 16.1743 14.0365 16.1743 14.0365ZM13.8539 6.94302C15.6112 8.70038 15.6112 11.5496 13.8539 13.307C12.0965 15.0643 9.24725 15.0643 7.48989 13.307C5.73254 11.5496 5.73254 8.70038 7.48989 6.94302C9.24725 5.18566 12.0965 5.18566 13.8539 6.94302C15.6112 8.70038 13.8539 6.94302 13.8539 6.94302Z"
              fill="#6E747A"
            />
          </g>
        </svg>
      </b-form-group>
    </div>

    <div
      v-if="loading"
      class="flex items-center justify-center w-full h-full mt-8"
    >
      <b-spinner variant="primary" />
    </div>

    <div
      v-else
      class="flex flex-col w-full mt-8 mx-2 border border-[#E2E5EC] rounded-sm"
    >
      <template v-if="!searchQuery">
        <PagePreviewFolder
          v-for="folder in folders"
          :key="folder.id"
          :folder="folder"
          class="border-[#E2E5EC] border-b last:border-none"
          @click="fetchPages"
        >
          <PagePreviewItem
            v-for="page in pages.filter(p => p.category_id === folder.id)"
            :key="page.id"
            :page="page"
            :domain="project.domain || `${project.subdomain}.estage.site`"
            class="border-[#E2E5EC] border-b last:border-none !pl-8"
          />
        </PagePreviewFolder>
        <PagePreviewItem
          v-for="page in pages.filter(p => p.category_id === null || p.category_id === 0)"
          :key="page.id"
          :page="page"
          :domain="project.domain || `${project.subdomain}.estage.site`"
          class="border-[#E2E5EC] border-b last:border-none"
        />
      </template>
      <template v-else>
        <PagePreviewItem
          v-for="page in pages"
          v-if="pages.length"
          :key="page.id"
          :page="page"
          :domain="project.domain || `${project.subdomain}.estage.site`"
          class="border-[#E2E5EC] border-b last:border-none"
        />
        <div
          v-else
          class="text-center text-[14px] pt-3 pb-2"
        >
          No pages
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>
import PagePreviewItem from '@/layouts/dashboard/compontens/folders/components/PagePreviewItem.vue'
import PagePreviewFolder from '@/layouts/dashboard/compontens/folders/components/PagePreviewFolder.vue'

export default {
  name: 'PageLinksPreview',
  components: {
    PagePreviewFolder,
    PagePreviewItem
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    project: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      searchQuery: '',
      pageQuery: 1,
      folders: [],
      pages: [],
      openedFolders: [],
      timeout: null
    }
  },
  computed: {
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
    // pagesList () {
    //   if (this.searchQuery) {
    //     return this.pages.filter(p => !this.searchQuery || p.title.toLowerCase().includes(this.searchQuery.toLowerCase()) || p.slug.toLowerCase().includes(this.searchQuery.toLowerCase()))
    //   }
    //   return this.pages.filter(p => p.category_id === null || p.category_id === 0)
    // }
  },
  methods: {
    async fetchPages (category = null) {
      const params = {
        page: this.pageQuery,
        q: this.searchQuery,
        parentId: category,
        per_page: 100
      }
      
      if (this.openedFolders.includes(category)) {
        return
      }

      if (category) {
        params.parentId = category
        this.openedFolders.push(category)
      }

      await axios.get(`api/projects/${this.project.id}/pages/with-categories`, {params})
        .then(({data}) => {
          data.data.categories.map(({id, name}) => {
            const index = this.folders.findIndex(f => f.id === id)
            if (index === -1) {
              this.folders.push({
                id,
                name
              })
            }
          })
          data.data.data
            .map(({id, slug, title, category_id, page_status, hash, css_file}) => {
              const index = this.pages.findIndex(f => f.id === id)
              if (index === -1) {
                this.pages.push({
                  id,
                  slug,
                  title,
                  category_id,
                  page_status,
                  hash,
                  css_file
                })
              }
            })
        })
    },
    async onSearch () {
      if (this.timeout) clearTimeout(this.timeout)

      this.timeout = setTimeout(async () => {
        this.folders = []
        this.pages = []
        this.openedFolders = []
        this.loading = true

        await this.fetchPages()

        this.loading = false
      }, 500)
    }
  },
  watch: {
    async modal (val) {
      if (val) {
        this.folders = []
        this.pages = []
        this.openedFolders = []
        this.loading = true
        await this.fetchPages()
        this.loading = false
      }
    }
  }
}
</script>
